/**
 *
 */
export function stickyHeader() {

	const header = document.getElementById( 'page-header' );
	const sticky = header.offsetTop;

	if ( window.pageYOffset > sticky ) {

		header.classList.add( 'page-header__sticky' );

	} else {

		header.classList.remove( 'page-header__sticky' );

	}

}

/**
 *
 */
export function handleScroll() {

	window.onscroll = stickyHeader;

}

/**
 *
 */
export function subMenu() {

	const hamburger = document.querySelector( '#navigation-toggle' )
	const pageHeader = document.querySelector( '.page-header' );
	const menuItems = document.querySelectorAll( '.menu__item' );
	const closeBtn = document.querySelector( '.page-header__close-button' );
	const activeMenuItem = document.querySelector( '.menu__item--active' );
	const closeContact = document.querySelector( '.menu-item--contact-close' );

	hamburger.addEventListener( 'click', () => {

		if ( hamburger.checked ) {

			document.body.classList.add( 'freeze' )

		} else {

			document.body.classList.remove( 'freeze' )

		}

	} )

	hamburger.addEventListener( 'change', function handleHamburgerClick() {

		if ( hamburger.checked ) {

			pageHeader.classList.add( 'page-header__navigation-toggle-checked' );

		} else {

			pageHeader.classList.remove( 'page-header__navigation-toggle-checked' );

		}

	} );

	if ( closeContact ) {

		closeContact.addEventListener( 'click', function handleContactCloseClick() {

			document.body.classList.remove( 'freeze' )
			hamburger.checked = false;
			pageHeader.classList.remove( 'page-header__navigation-toggle-checked' );

		} );

	}
	menuItems.forEach( ( menuItem ) => {

		menuItem.addEventListener( 'click', function handleClick( e ) {

			const hasChildren = e.target.closest( '.menu-item-has-children > .item__link' );

			if ( hasChildren ) {

				e.preventDefault();

			}

			e.stopPropagation();
			menuItem.classList.toggle( 'menu__item--active' );
			menuItems.forEach( ( item ) => {

				if ( item !== menuItem ) {

					const otherMenuItem = item.classList.contains( 'menu__item--active' );
					if ( otherMenuItem ) {

						item.classList.remove( 'menu__item--active' );

					}

				}

			} );

		} );

	} );

	if ( closeBtn ) {

		closeBtn.addEventListener( 'click', function handleButtonClick() {

			activeMenuItem.forEach( ( item ) => {

				item.classList.remove( 'menu__item--active' );

			} );

		} );

	}

}

